module.exports = __webpack_public_path__ + "static/stepfunction_4-6983d2cb705fb4c3ac93eb6e8ab95b45.png";